export default __webpack_public_path__ + "static/media/ally.0fc44bcf.png";